import { Row } from "antd";
import styled from "styled-components";

export const StakingProduct = styled.div`
  width: 100%;
  padding: 19px 30px 4px 30px;
  background: #ffffff;
  border-radius: 15px;
  @media (max-width: 1024px) {
    padding: 22px 19px 5px 19px;
  }
`;

export const StakeDetailContent = styled.div`
  width: 650px;
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  background: #ffffff;
  border-radius: 24px;
  padding: 21px 40px;
  @media (max-width: 1024px) {
    padding: 16px 15px 22px 20px;
  }
`;

export const StatusStakingProduct = styled.div`
  width: 85px;
  height: 30px;
  background: rgba(60, 103, 174, 0.1);
  border-radius: 0px 10px;
  color: #485ea8;
  @media (max-width: 1024px) {
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    text-align: center;
    color: #485ea8;
  }
`;

export const TextItemDetail = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 40px;
  color: #000000;
  align-items: center;
  @media (max-width: 1024px) {
    font-size: 14px;
  }
`;

export const TextAddress = styled(TextItemDetail)`
  display: inline-block;
  max-width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media (max-width: 640px) {
    max-width: 190px;
  }
`;

export const Separation = styled.div`
  height: 17px;
  width: 2px;
  background-color: #707070;
`;

export const BlockInfoWallet = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 30px;
  flex-wrap: wrap;
  background: #ffffff;
  border-radius: 15px;
  @media (max-width: 640px) {
    padding: 25px 19px 25px 19px;
  }
`;

export const TextItemDetail3 = styled.span`
  font-size: 16px;
  line-height: 50px;
  color: #707070;
  @media (max-width: 1024px) {
    font-size: 10px;
    line-height: 12px;
  }
`;

export const TextItemDetail1 = styled.span`
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  color: #818181;
  @media (max-width: 1024px) {
    font-weight: 400;
    font-size: 10px;
    line-height: 12px;
    color: #818181;
  }
`;

export const TextItemDetail2 = styled.span`
  font-weight: ${(props) => props.weight || 400};
  font-size: 16px;
  line-height: 19px;
  color: #000000;
  @media (max-width: 1024px) {
    font-size: 12px;
    line-height: 15px;
    color: #000000;
  }
`;

export const TagStatus = styled.div`
  width: 105px;
  height: 30px;
  background: rgba(255, 116, 37, 0.1);
  border-radius: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ff7425;

  font-weight: 400;
  font-size: 13px;
  line-height: 24px;

  &.Active {
    color: #F12E11;
    background: #F5AA194D;
  }
  &.Finished {
    color: #4d67c1;
    background: rgba(77, 103, 193, 0.1);
  }
  &.Closed {
    color: #707070;
    background: rgba(112, 112, 112, 0.1);
  }
  @media (max-width: 1024px) {
    width: 75px;
    height: 25px;
    border-radius: 30px;

    font-weight: 400;
    font-size: 11px;
    line-height: 24px;
  }
`;

export const StakingOrderContainer = styled.div`
  background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
  border: 1px solid rgba(112, 112, 112, 0.2);
  border-radius: 0 0 64px 64px;
  padding: 0px 73px 3px;
  @media (max-width: 1024px) {
    border-radius: 20px;
    padding: 10px 20px 8px 20px;
    background: linear-gradient(157.48deg, #ffffff -5.34%, #ffffff 103.65%);
    border: 1px solid rgba(112, 112, 112, 0.2);
  }
`;

export const HeaderTableStake = styled(Row)`
  background: rgba(0, 0, 0, 0.05);

  border: 1px solid rgba(112, 112, 112, 0.2),
  border-bottom: none;

  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  text-align: center;
  background: #EAEAEA;
height: 55px;
border-radius: 64px 64px 0px 0px;
  padding: 0 50px;
  & .ant-col {
    display: flex;
    align-items: center;
    // justify-content: center;
  }
`;

export const TitleModalFilter = styled.div`
  width: 100%;
  font-weight: 700;
  font-size: 24px;
  line-height: 33.6px;
  text-align: center;
  letter-spacing: -0.96px;
  

  @media (max-width: 640px) {
    font-size: 24px;
  }
`;

export const TitleTextFiter = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 15px;
  text-align: center;
  color: #4f4f4f;
`;

export const LabelFormFilter = styled.span`
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #707070;
`;

export const Tag = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 35px;
  min-width: 65px;
  background: rgba(84, 143, 235, 0.1);
  border: 1px solid transparent;
  border-radius: 7px;
  padding: 8px;
  cursor: pointer;

  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #4f4f4f;
  &.checked {
    border: 1px solid #F12E11;
  }
  @media (max-width: 640px) {
    font-size: 14px;
    line-height: 17px;
  }
`;
